import { Box, Select, Flex, Text } from '@chakra-ui/react'

export const HistoryChart = () => {
  return (
    <Box>
      <Flex gap={4} mb={4}>
        <Box>
          <Text mb={2}>Real Observables</Text>
          <Select placeholder="Select parameter">
            <option value="temp">Temperature</option>
            <option value="pressure">Pressure</option>
            <option value="flow">Flow Rate</option>
          </Select>
        </Box>
        <Box>
          <Text mb={2}>Virtual Gauges</Text>
          <Select placeholder="Select parameter">
            <option value="model1">Model Output 1</option>
            <option value="model2">Model Output 2</option>
            <option value="model3">Model Output 3</option>
          </Select>
        </Box>
      </Flex>
      
      <Box p={4} border="1px" borderColor="gray.200" borderRadius="md">
        <Text color="gray.500" textAlign="center">Chart Placeholder</Text>
      </Box>
      
      {/* Time slider placeholder */}
      <Box mt={4} p={4} border="1px" borderColor="gray.200" borderRadius="md">
        <Text color="gray.500" textAlign="center">Time Range Slider</Text>
      </Box>
    </Box>
  )
} 